import type { ReactNode } from 'react'
import React from 'react'
import type { SvgIconProps } from '../SvgIcon/SvgIcon'
import SvgIcon from '../SvgIcon/SvgIcon'

function createSvgIcon(path: ReactNode, name: string): typeof SvgIcon {
  const component = (props: SvgIconProps): JSX.Element => (
    <SvgIcon {...props}>{path}</SvgIcon>
  )

  component.displayName = name
  component.uiName = 'SvgIcon'

  return component
}

export default createSvgIcon
